module.exports = __webpack_public_path__ + "img/icon_price_w.f4a3b96e.svg";